import React, { Component } from "react";
import axios from "services/axios";
import Axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import downloadExcel from "../../../services/downloadExcel";
import _get from "lodash/get";
import {
  Button,
  Card,
  message,
  Tag,
  Tooltip,
  Input,
  Icon,
  Modal,
  DatePicker,
  Spin,
  Switch,
} from "antd";
import { connect } from "react-redux";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import { formatNumber } from "../../Utils";

const confirmDelete = Modal.confirm;
const { RangePicker } = DatePicker;

class Appraisal extends Component {
  state = {
    search: "",
    appraisal: [],
    visibleConfirmModal: false,
    confirmLoading: false,
    rangeTime: [],
    isDataReady: false,
    count: 1,
    page: 0,
    rowPerPage: 15,
    limit: 15,
    isAppraiserAppDisabled: false,
  };

  formatDate = (record) => {
    if (
      record.Booking.CarInquiry !== null &&
      record.misc.finishedAppraisalTime
    ) {
      let number = moment(record.Booking.CarInquiry.createdAt).diff(
        moment(record.misc.finishedAppraisalTime),
        "minute"
      );

      if (number < 60) {
        return `${number} M`;
      } else {
        let hour = Math.floor(number / 60);
        let minute = number % 60;
        if (hour > 24) {
          let day = Math.floor(hour / 24);
          let lefthour = hour % 24;

          return `${day} H ${lefthour} J ${minute} M`;
        } else {
          if (minute !== 0) {
            return `${hour} J ${minute} M`;
          } else {
            return `${hour} J`;
          }
        }
      }
    } else {
      return "";
    }
  };

  mapForDownloadCsv = (data, Type) => {
    let dataTable = data.map((d) => {
      let carType = Type.find((type) => type.id == d.carSummary[2].value);

      let finishTime = _get(d, "misc.finishedAppraisalTime");
      let nomorMesin = {};
      let nomorRangka = {};
      let pajak = {};
      let kilometer = {};

      if (d && Array.isArray(d.carDetail)) {
        pajak = d.carDetail.find((v) => v.fieldName === "Pajak Satu Tahun");
        kilometer = d.carDetail.find((v) => v.fieldName === "Jarak Tempuh");
        nomorMesin = d.carDetail.find((v) => v.fieldName === "Nomor Mesin");
        nomorRangka = d.carDetail.find((v) => v.fieldName === "Nomor Rangka");
      }

      return {
        "Tanggal Booking": moment(_get(d, "Booking.bookingTime")).format(
          "DD/MM/YYYY HH:mm"
        ),
        "Tanggal Assign": moment(_get(d, "createdAt")).format(
          "DD/MM/YYYY HH:mm"
        ),
        "Hari/Tanggal Appraisal Mulai": d.startTimeAppraisal
          ? moment(_get(d, "startTimeAppraisal")).format("DD/MM/YYYY HH:mm")
          : "-",

        "Hari/Tanggal Appraisal Selesai": finishTime
          ? moment(finishTime).format("DD/MM/YYYY HH:mm")
          : "-",
        "Id Mobbi": d.Booking.MobbiPayload
          ? d.Booking.MobbiPayload.mobbiId
          : "",
        "Id Booking": d.Booking.noBooking,
        "Status Appraisal": d.status,
        "Alasan Cancel": d.Booking
          ? d.Booking.cancelReason
            ? `${d.Booking.cancelReason} - ${d.Booking.cancelNotes}`
            : "-"
          : "-",
        "No. Polisi": _get(d, "carDetail[7].value"),
        Merk: _get(d, "carDetail[3].value"),
        // Model: carType ? carType.model : _get(d, "carDetail[4].value"),
        // Tipe: carType ? carType.type : _get(d, "carDetail[5].value"),
        Model: _get(d, "carDetail[4].value"),
        Tipe: _get(d, "carDetail[5].value"),
        Transmission: carType
          ? carType.transmission
          : _get(d, "carSummary[3].value"),
        Tahun: _get(d, "carDetail[6].value"),
        Kilometer: kilometer ? formatNumber(kilometer.value) : "",
        "Nomor Mesin": nomorMesin ? nomorMesin.value : "",
        "Nomor Rangka": nomorRangka ? nomorRangka.value : "",
        Pajak: pajak ? pajak.value : "",
        "Nama Customer": _get(d, "carDetail[0].value"),
        "No. Hp Customer": _get(d, "carDetail[1].value"),
        "Email Customer": _get(d, "carDetail[2].value"),
        "Nama Sales": _get(d, "Booking.SalesProfile.name"),
        Cabang: _get(d, "Booking.SalesProfile.SalesBranch.branch"),
        "No. Hp Sales": _get(d, "Booking.SalesProfile.phone"),
        "Nama Appraiser": _get(d, "Booking.Appraiser.name"),
      };
    });
    downloadExcel(dataTable, "appraisal_report");
  };

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  formatStatus = (item) => {
    switch (item.status) {
      case "FINISHED":
        return <Tag color="green">FINISHED</Tag>;
      // return item.misc && item.misc.priceConfirmation.status ? (
      //   <Tag color="green">FINISHED</Tag>
      // ) : (
      //   <Tag color="magenta">WAITING</Tag>
      // );
      case "CANCEL":
        return <Tag color="red">{item.status}</Tag>;
      case "ASSIGNED":
        return <Tag color="magenta">WAITING</Tag>;
      default:
        return <Tag>{item.status}</Tag>;
    }
  };

  deleteAppraisal(id) {
    let self = this;
    confirmDelete({
      title: "Anda yakin ingin menghapus appraisal ini ?",
      content: "Jika Anda klik OK, maka appraisal ini akan dibatalkan",
      onOk() {
        axios
          .delete(`appraisal/${id}/delete`, {
            headers: {
              Authorization: self.props.Auth.token,
            },
          })
          .then((response) => {
            message.success("Appraisal berhasil dihapus");
            self.fetchAppraisal();
          })
          .catch((err) => {
            message.error("Gagal menghapus appraisal");
          });
      },
      onCancel() {
        message.warning("Batal menghapus appraisal");
      },
    });
  }

  formatDate = (number) => {
    if (number < 60) {
      return `${number} Menit`;
    } else {
      let hour = Math.floor(number / 60);
      let minute = number % 60;
      if (hour > 24) {
        let day = Math.floor(hour / 24);
        let lefthour = hour % 24;

        return `${day} Hari ${lefthour} Jam ${minute} Menit`;
      } else {
        if (minute !== 0) {
          return `${hour} Jam ${minute} Menit`;
        } else {
          return `${hour} Jam`;
        }
      }
    }
  };

  fetchAppraisal(page = 1, paginate = 15, query) {
    // if (!query) query = "";
    axios
      .get(
        `/admin-panel/appraisal?search=${
          this.state.search || ""
        }&page=${page}&limit=${paginate}`
      )
      .then((result) => {
        this.setState({
          appraisal: result.data.appraisal,
          isDataReady: true,
          count: result.data.count,
          page: result.data.page,
          limit: result.data.limit,
        });
      })
      .catch((err) => {
        message.error("Gagal request data appraisal");
      });
  }

  fetchAppraiserAppStatus() {
    // if (!query) query = "";
    axios
      .get(`/admin-panel/appraiser-app/status`)
      .then((result) => {
        this.setState({
          isAppraiserAppDisabled: result.data.isDisable,
        });
      })
      .catch((err) => {
        message.error("Gagal request data appraisal");
      });
  }

  updateAppraiserAppStatus(isDisable) {
    // if (!query) query = "";
    this.setState({ isDataReady: false });
    axios
      .put(`/admin-panel/appraiser-app/status`, { isDisable })
      .then((result) => {
        this.setState({
          isAppraiserAppDisabled: result.data.isDisable,
          isDataReady: true,
        });
      })
      .catch((err) => {
        message.error("Gagal update appraiser app status");
        this.setState({ isDataReady: false });
      });
  }

  changePage(page, paginate, query) {
    this.setState({ isDataReady: false }, () =>
      this.fetchAppraisal(page, paginate, query)
    );
  }

  componentDidMount() {
    const { Auth } = this.props;
    this.fetchAppraisal();
    if (Auth.user.role === "SUPER_ADMIN" || Auth.user.role === "GP_ADMIN") {
      this.fetchAppraiserAppStatus();
    }
  }

  visibleModalConfirmation() {
    this.setState({
      visibleConfirmModal: !this.state.visibleConfirmModal,
    });
  }

  async confirmationDownload() {
    const { rangeTime } = this.state;
    if (rangeTime.length > 0) {
      Axios.post(
        `${process.env.REACT_APP_API_URL}/admin-panel/appraisal/download`,
        {
          rangeTime,
        }
      )
        .then((result) => {
          if (result.data.appraisals.length > 0) {
            this.mapForDownloadCsv(
              result.data.appraisals,
              this.props.Car.carType
            );
            this.visibleModalConfirmation();
          } else {
            message.error("Data Appraisal Kosong");
          }
        })
        .catch((err) => {
          message.error("Gagal mendapatkan data Appraisal");
        });
    }
  }

  onChangeRange(date, dateString) {
    this.setState({
      rangeTime: dateString,
    });
  }

  getCarType = (brandId, modelId, typeId) => {
    const { Car } = this.props;
    let brand = Car.carBrand.find((brand) => brand.id == brandId);
    let model = Car.carModel.find((model) => model.id == modelId);
    let type = Car.carType.find((ctype) => ctype.id == typeId);
    return `${brand ? brand.brand : ""} ${model ? model.carType : ""} ${
      type ? type.type + " " + type.transmission : ""
    } `;
  };

  render() {
    const { Auth } = this.props;
    const columns = [
      "Action",
      "Status",
      "Mobbi ID",
      "Booking ID",
      "Plat Nomor",
      "Car Type",
      {
        name: "Hari/Tgl Appraisal",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>{moment(value).format("YYYY-MM-DD HH:mm")}</div>;
          },
        },
      },
      "Appraisal Name",
      "Cabang",
      "Area",
      // "Plat Nomor",
      {
        name: "Order Log",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>{moment(value).format("YYYY-MM-DD HH:mm")}</div>;
          },
        },
      },
      "Lead Time",
      // "No Booking"
    ];

    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "400px",
      print: false,
      selectableRows: "none",
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    const data = this.state.appraisal.map((item) => {
      return [
        <div>
          <Link to={`/home/appraisal/${item.id}`}>
            <Tooltip placement="bottom" title="Detail Appraisal">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>{" "}
          {/* {this.props.Auth.user.role === "SUPER_ADMIN" && item.status !== "CANCEL" ? (
            <Tooltip placement="bottom" title="Delete Appraisal">
              <Button type="danger" icon="delete" onClick={() => this.deleteAppraisal(item.id)} />
            </Tooltip>
          ) : null} */}
        </div>,
        this.formatStatus(item),
        item.Booking.MobbiPayload ? item.Booking.MobbiPayload.mobbiId : "",
        item.Booking.noBooking,
        item
          ? item.lisencePlate || (item.carDetail && item.carDetail[7].value)
          : "",
        // item.carSummary[0].value == ""
        //   ? `${item.carDetail[3].value} ${item.carDetail[4].value} ${item.carDetail[5].value}`
        //   : this.getCarType(
        //       item.carSummary[0].value,
        //       item.carSummary[1].value,
        //       item.carSummary[2].value
        //     ),
        item.carName,
        item.Booking.bookingTime,
        item.Booking.Appraiser ? item.Booking.Appraiser.name : "",
        item.Booking.SalesProfile.Branch
          ? item.Booking.SalesProfile.Branch.branch
          : "",
        item.Booking.SalesProfile.Branch
          ? item.Booking.SalesProfile.Branch.area
          : "",
        // item.Booking.SalesProfile.Branch.AreaPricing.kodePlat,
        item.updatedAt,
        // item.Booking.noBooking,
        item.leadTime ? item.leadTime + " Menit" : "0 Menit",
      ];
    });

    return (
      <Card
        title="List Appraisal"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 5, width: "100%", display: "flex" }}>
          <Button
            onClick={() => this.visibleModalConfirmation()}
            style={{ marginRight: 10 }}>
            Download Report
          </Button>
          {(Auth.user.role === "SUPER_ADMIN" ||
            Auth.user.role === "GP_ADMIN") && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                width: "85%",
              }}>
              <h3 style={{ marginRight: 10, marginBottom: 0 }}>
                On / Off Appraiser APP
              </h3>
              <Switch
                checked={!this.state.isAppraiserAppDisabled}
                onChange={() =>
                  this.updateAppraiserAppStatus(
                    !this.state.isAppraiserAppDisabled
                  )
                }
              />
            </div>
          )}
        </div>

        <Spin size="large" spinning={!this.state.isDataReady} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={"APPRAISAL"}
              data={data}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <Modal
          visible={this.state.visibleConfirmModal}
          title="Download Data Appraisal"
          onOk={() => this.confirmationDownload()}
          onCancel={() => this.visibleModalConfirmation()}
          confirmLoading={this.state.confirmLoading}>
          <p>Pilih range waktu finish Appraisal</p>
          <RangePicker
            format="YYYY-MM-DD HH:mm:ss"
            onChange={(date, dateString) =>
              this.onChangeRange(date, dateString)
            }
          />
        </Modal>
      </Card>
    );
  }
}

let mapStateToProps = ({ Auth, Car }) => ({ Auth, Car });
export default connect(mapStateToProps)(Appraisal);



// WEBPACK FOOTER //
// src/components/Dashboard/Appraisal/Appraisal.js